import {Injectable} from '@angular/core';
import {Router, CanActivate} from '@angular/router';
import * as _ from 'lodash';
import {DataService} from '../services/data.service';

@Injectable()
export class HomeGuard implements CanActivate {

  constructor(private router: Router,
              private auth: DataService) {
  }

  canActivate() {
    const isAuth = this.isCustomerAuthenticated();
    if (isAuth) {
      this.router.navigate(['/pages/dashboard']);
      return false;
    } else {
      return true;
    }
  }

  isCustomerAuthenticated(): boolean {
    const user = this.auth.get();
    return !_.isUndefined(user) && !_.isNull(user);
  }
}
